<template lang="html">
	<div id="page__manipulator" class="center-panel">
		<md-content md-theme="white" v-bind:loading="progress">
			<ManipulatorsMenu></ManipulatorsMenu>
			<sort-table
				v-bind:columns="tableColumns" v-model="prices" v-on:refresh="getPrices" v-bind:per-page="perPage" 
				v-bind:total="pricesAmount" link table-id="manipulatorprice" ref="table" v-on:create="addPrice" tableHeight="calc(100% - 48px)"
			>
				<template slot="actions" slot-scope="scope">
                    <z-icon-button v-bind:icon="['fa', 'trash']" v-on:click.stop.prevent="onRemove(scope.item.id)" danger-light rounded></z-icon-button>
                </template>
			</sort-table>
		</md-content>
	</div>
</template>
<script>
	import ManipulatorsMenu from './ManipulatorsMenu.vue';
	import SortTable   from '@/components/SortTable';
	import ZIconButton from '@/components/ZIconButton.vue';
	export default {
		components: { SortTable, ZIconButton, ManipulatorsMenu },
		data() {
			return {
				title: 'Услуга манипулятора',
				perPage: 50,
				tableColumns: [
					{ label: 'ID',  field: 'id',   default: true, sortable: true },
					{ label: 'Тип', field: 'type_name', sortable: true },
					{ label: 'Минимальный',     field: 'is_min_name', sortable: false},
					{ label: 'Мин. время (ч)',  field: 'min_time',    sortable: true },
					{ label: 'Цена (руб.)',     field: 'price',       sortable: true },
					{ label: 'Вес/Объём мин.',  field: 'value_min',   sortable: true },
					{ label: 'Вес/Объём макс.', field: 'value_max',   sortable: true },
					{ label: '', field: 'actions' }
				],
			}
		},
		computed: {
			/**
             * Флаг загрузки текущего компонента
             */
            progress() {
                return this.progressObj['get-manipulatorprice-list'];
            },
            /**
             * Объект с флагами загрузки
             */
            progressObj() {
                return this.$store.state.progressObj;
            },
			/**
			 * Список городов
			 */
			prices() {
				return this.$store.state.cost.manipulator_prices.map(price => {
					price.routerLink  = {name: 'ManipulatorPrice', params: {id: price.id}, query: this.$route.query};
                    price.type_name   = parseInt(price.type) === 1 ? 'По весу' : parseInt(price.type) == 2 ? 'По объёму' : 'Не определено'
					price.is_min_name = parseInt(price.is_min) === 1 ? 'Да' : 'Нет'
					return price;
				});
			},
			/**
			 * Количество городов
			 */
			pricesAmount() {
				return this.$store.state.cost.manipulator_prices_amount
			}
		},
		created() {
			this.$store.commit('setTitle', this.title)
		},
		methods: {
			/**
			 * Добавление города
			 */
			addPrice() {
				this.$router.push({ name: 'ManipulatorPrice', params: {id: 'new'} });
			},
			/**
			 * Получение городов
			 */
			getPrices(page, count, orderBy, orderType, filter) {
				this.$store.commit('showProgressBar', 'get-manipulatorprice-list');
				return this.$store.dispatch('cost/getManipulatorPrices', {
					page: page, 
					order_by:   orderBy, 
					order_type: orderType, 
					count: count,
					filter: this.resolveQueryFilter()
				}).finally(() => this.$store.commit('hideProgressBar', 'get-manipulatorprice-list'));
			},
			/**
			 * Фильтрация
			 */
			resolveQueryFilter() {
				if (!this.$route.query || !this.$route.query.filter) return null;
				let filter = Object.assign({}, JSON.parse(this.$route.query.filter)), model = [], result = {model: [], relation: [], condition: 'and'};

                if (filter.type) model.push(['type', '=', filter.type]);

                model.map((item, i) => {
                    result.model.push(item);
                    if (model[i+1]) result.model.push('and');
                });

				return result;
			},
			/**
			 * Удаление города
			 */
			removePrice(id) {
				if (!id) return;
				this.$store.commit('showProgressBar', 'get-manipulatorprice-list');
				this.$store.dispatch('cost/deleteManipulatorPrice', id)
					.then(() => this.$root.$emit('refresh-table', 'manipulatorprice'))
					.finally(() => this.$store.commit('hideProgressBar', 'get-manipulatorprice-list'));
			},
			/**
			 * Модальное окно с подтверждением удаления города
			 */
			onRemove(id) {
                this.$root.$emit(
                    'z-alert', 'Вы уверены в удалении цены?', 'Действие необратимо!',
                    () => this.removePrice(id)
                );
            },
		},
	}
</script>


// WEBPACK FOOTER //
// Manipulators.vue?22a0534c